<ng-container *mobxAutorun>
  <nav class="navbar navbar-expand-lg justify-content-between">
    <!-- Tree toggle + title + pending icon -->
    <div class="navbar-brand">
      <!-- Small screen: show tree-nav button -->
      <button
        lf-button
        class="tree-nav-show d-md-none"
        [style]="'outline-secondary'"
        (click)="showTreeNav()"
      >
        <lf-icon icon="bars"></lf-icon>
      </button>

      <!-- Title -->
      <a
        class="navbar-title"
        [routerLink]="rootUrl"
        queryParamsHandling="merge"
      >
        <ng-content></ng-content>
      </a>

      <!-- Pending app validation -->
      <div class="pending-app" *ngIf="appIsPending"></div>

      <!-- Rejected app validation -->
      <div
        class="rejected-app"
        *ngIf="shouldShowAppRecompute"
        (click)="recomputeAppStateProperties()"
      >
        <lf-tooltip [help]="retryValidationText" placement="right">
          <lf-icon icon="warning"></lf-icon>
        </lf-tooltip>
      </div>
    </div>

    <!-- Application actions -->
    <lf-actions-menu [actions]="actions" [alignMenusRight]="true">
    </lf-actions-menu>
  </nav>
</ng-container>
